<template>
  <div class="aboutUs">
    <Banner :type="2">
      <template>
        <div class="platform-intro">
          <div class="intro-container">
            <div class="intro-text">
              <h2 class="intro-subtitle">平台简介</h2>
              <p class="intro-desc">
                安康市涉农信用信息平台，依托地方公共信用大数据中心和地方金融平台，广泛收集了地方公共信用信息、地方金融机构和涉农信用信息等涉农信用信息等多维数据，构建"政、银、农、信"信用信息共享应用，利用大数据、智能分析等金融科技手段，以解决农业经营主体融资难和金融机构产品创新难、风控难等问题提供"一站式"服务平台。尤其是信用良好的新型农业主体、农户和农户，都可以在公共信用平台获得银行授信和融资服务平台，推动农业经济持续健康发展。
              </p>
            </div>
            <div class="intro-image"></div>
          </div>
        </div>
      </template>
    </Banner>
    <!-- 帮助中心区域 -->
    <div class="help-center">
      <div class="help-container">
        <div class="help-header">
          <div class="help-title">
            <span class="help-title-cn">帮助中心</span>
            <span class="help-title-en">HELP CENTER</span>
          </div>
        </div>

        <div class="question-list">
          <div
            class="question-item"
            v-for="(item, idx) in questionList"
            :key="idx"
          >
            <div class="question-title" @click="getSelectIdx(idx)">
              <div class="question-dot">{{ idx + 1 }}</div>
              <span class="question-text">{{ item.title }}</span>
              <i
                class="el-icon-arrow-right"
                :class="{ 'is-active': selectIdx === idx }"
              />
            </div>
            <div v-show="selectIdx === idx" class="question-content">
              {{ item.content }}
            </div>
          </div>
        </div>

        <div class="page" v-show="pagination.total > 10">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 50, 100]"
            :current-page.sync="pagination.page"
            :page-size.sync="pagination.size"
            :total="pagination.total"
            @current-change="getQuestionArr"
            @size-change="queryData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* API 导入 */
import { getQuestionList } from "@/api";
import Banner from "@/components/Banner";
export default {
  name: "aboutUs",
  components: {
    Banner,
  },
  data() {
    return {
      questionList: [],
      selectIdx: null,
      pagination: {
        page: 1,
        size: 10,
        total: 0,
      },
    };
  },
  methods: {
    /** 获取问题列表 */
    async getQuestionArr() {
      const res = await getQuestionList({
        current: this.pagination.page,
        size: this.pagination.size,
      });
      if (res && res.data) {
        this.questionList = res.data.records;
        this.pagination.total = res.data.total;
      }
    },

    /** 切换问题展开/收起 */
    getSelectIdx(idx) {
      if (this.selectIdx === idx) {
        this.selectIdx = null;
      } else {
        this.selectIdx = idx;
      }
    },

    /** 重置分页并查询 */
    queryData() {
      this.pagination.page = 1;
      this.getQuestionArr();
    },
  },
  mounted() {
    this.getQuestionArr();
  },
};
</script>

<style scoped>
.aboutUs {
  min-height: calc(100vh - 230px);
  min-width: 1200px;
  background: linear-gradient(180deg, #f0f6ff 0%, #e6f1ff 50%, #e3ecff 100%);
}

/* 平台简介区域 */
.platform-intro {
  width: 100%;
  min-height: 200px;
  /* background: linear-gradient(135deg, #a8d4f5 0%, #c5e2f7 30%, #e0eef8 60%, #d0e4f5 100%); */
  position: relative;
  overflow: hidden;
}

.intro-container {
  width: 1500px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* padding: 60px 0; */
  position: relative;
  z-index: 1;
}

.intro-text {
  max-width: 700px;
  flex-shrink: 0;
  padding: 0 20px;
}

.intro-title {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 40px;
  line-height: 1.4;
  color: #1366ec;
  margin: 0 0 16px 0;
}

.intro-subtitle {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 1.4;
  color: #1366ec;
  margin: 0 0 24px 0;
}

.intro-desc {
  text-indent: 2em;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  line-height: 1.8;
  color: #183874;
  text-align: justify;
  margin: 0;
  padding: 20px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  font-size:16px;
  box-shadow: -4px 2px 8px rgba(0, 0, 0, 0.08);
}

/* 右侧插图占位 */
.intro-image {
  width: 500px;
  height: 350px;
  flex-shrink: 0;
  /* 实际使用时替换为真实插图 */
  /* background-image: url('~@/assets/images/platform-intro-3d.png'); */
  /* background-size: contain; */
  /* background-position: center; */
  /* background-repeat: no-repeat; */
}

/* 帮助中心区域 */
.help-center {
  width: 100%;
  flex: 1;
  padding: 40px 0 60px;
}

.help-container {
  width: 1500px;
  margin: 0 auto;
}

.help-header {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
}

.help-title {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.help-title-cn {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 24px;
  color: #000000;
}

.help-title-en {
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #cecdcd;
  letter-spacing: 0.05em;
}

/* 问题列表 */
.question-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.question-item {
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.question-title {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  cursor: pointer;
  transition: background 0.3s;
  background: #ffffff;
  border-radius: 16px;
}

.question-title:hover {
  background: #f8faff;
}

.question-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1366ec;
  flex-shrink: 0;
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
}

.question-text {
  flex: 1;
  font-family: "PingFang SC", sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #333333;
}

.question-title i {
  font-size: 14px;
  color: #999999;
  transition: transform 0.3s;
  flex-shrink: 0;
  margin-left: 12px;
}

.question-title i.is-active {
  transform: rotate(90deg);
}

.question-content {
  margin-top: 20px;
  padding: 18px 43px;
  font-family: "PingFang SC", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.8;
  color: #666666;
  background: #ffffff;
  border-radius: 16px;
}

/* 分页 */
.page {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
</style>
